/* eslint camelcase: 0 */
import _ from 'lodash';
import { ArchivalAction } from '../../constants/filter';
import {
    TooAddressSnapshot,
    TooQuoteSnapshot,
    TooResidentialPurchaseSnapshot,
} from '../../models';
import api from '../api';
import { getBackVersion } from '../../config';

type TooResidentialPurchaseResponse = Omit<
    TooResidentialPurchaseSnapshot,
    'addresses' | 'quotes' | 'currentQuote' | 'propertyType'
> & {
    addresses: TooAddressSnapshot[];
    quote: TooQuoteSnapshot | null;
};

// eslint-disable-next-line complexity
const toSnapshot = (
    response: TooResidentialPurchaseResponse
): TooResidentialPurchaseSnapshot => {
    return {
        ...response,
        propertyType: response.quote?.quoteInput.propertyType ?? null,
        addresses: _.keyBy(response.addresses, x => x.type),
        quotes: response.quote ? { [response.quote.id]: response.quote } : {},
        autoFillZipcode:
            response.addresses.find(x => x.type === 'risk_site')?.zipcode ??
            null,
        autoFillCpf: response.beneficiary?.cpf ?? null,
        currentQuote: response.quote,
        rentValue: response.quote?.quoteInput?.fire
            ? response.quote.quoteInput.fire / 100
            : null,
    };
};

const createInsurance = (): Promise<TooResidentialPurchaseSnapshot> =>
    api
        .request<TooResidentialPurchaseResponse>({
            url: `${getBackVersion()}/agent/insurances/residential/too`,
            method: 'POST',
        })
        .then(toSnapshot);

const getInsurance = (
    insuranceId: string
): Promise<TooResidentialPurchaseSnapshot> =>
    api
        .request<TooResidentialPurchaseResponse>({
            url:
                `${getBackVersion()}/agent/insurances/residential/too/` +
                insuranceId,
            method: 'GET',
        })
        .then(toSnapshot);

const patchInsurance = (
    insuranceId: string
): Promise<TooResidentialPurchaseSnapshot> =>
    api
        .request<TooResidentialPurchaseResponse>({
            url:
                `${getBackVersion()}/agent/insurances/residential/too/` +
                insuranceId,
            method: 'PATCH',
        })
        .then(toSnapshot);

const archiveInsurance = (
    insuranceId: string,
    action: ArchivalAction
): Promise<void> => {
    return api.request({
        url:
            `${getBackVersion()}/agent/insurances/residential/too/` +
            insuranceId,
        method: 'DELETE',
        params: { action },
    });
};

export { archiveInsurance, createInsurance, getInsurance, patchInsurance };
